import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Wrapper, LogoItem, Logo, CountryWrapper, CountryText, CountryImage, NavWrapper, MenuWrapper, MenuItem, HambWrapper, LogoWrapper, FullScreenWrapper } from "./HeaderStyle"
import { GiHamburgerMenu } from "react-icons/gi";
import User from "./user/User"
import enFlag from "./01_images/united-kingdom.png"
import ukFlag from "./01_images/ukraine.png"
import { header } from "../../i18n/01_header";
import { setLang } from "../../features/language/languageSlice";

const Header = () => {

  const lang = useSelector(state => state.lang.lang)
  const t = header[lang]

  const flagMap = {
    en: ukFlag,
    uk: enFlag
  }

  const dispatch = useDispatch()


  const [userMenu, setUserMenu] = useState(false)
  const [hambMenu, setHambMenu] = useState(false)

  const clickLanguage = () => {
    dispatch(setLang(lang === "en" ? "uk" : "en"))
  }

  const clickHambMenu = () => {
    setUserMenu(false)
    setHambMenu(!hambMenu)
  }

  const clickOutside = () => {
    setHambMenu(false)
  }

  return (
    <Wrapper>
      <FullScreenWrapper
        onClick={clickOutside}
        onTouchMove={clickOutside}
        hambMenu={hambMenu}
      ></FullScreenWrapper>
      <LogoWrapper>
        <Logo to="/">TeachLearn.co.uk</Logo>
        <CountryWrapper
          onClick={clickLanguage}
        >
          <CountryText>{t.logo}</CountryText>
          <CountryImage
            src={flagMap[t.image]}
          />
        </CountryWrapper>
      </LogoWrapper>
      <NavWrapper>
        <HambWrapper onClick={clickHambMenu}>
          <GiHamburgerMenu />
        </HambWrapper>
        <MenuWrapper hambMenu={hambMenu} onClick={clickHambMenu}>
          {t.menu.map((value, index) => (
            <MenuItem key={index} to={value.to}>
              {value.label}
            </MenuItem>
          ))}
        </MenuWrapper>
        <User
          userMenu={userMenu}
          setUserMenu={setUserMenu}
          hambMenu={hambMenu}
          setHambMenu={setHambMenu}
        />
      </NavWrapper>
    </Wrapper>
  )
}

export default Header